import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=1db96666&scoped=true"
import script from "./notice-detail.vue?vue&type=script&lang=js"
export * from "./notice-detail.vue?vue&type=script&lang=js"
import style0 from "./notice-detail.vue?vue&type=style&index=0&id=1db96666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db96666",
  null
  
)

export default component.exports